// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeaS1fFr {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 2rem 1rem;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
}
.LeaS1fFr::before {
  content: '';
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: -1;
  pointer-events: none;
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .LeaS1fFr {
    display: block;
    -webkit-box-align: initial;
    -webkit-align-items: initial;
            align-items: initial;
    -webkit-box-pack: initial;
    -webkit-justify-content: initial;
            justify-content: initial;
    padding: 0.75rem 1rem;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
  }
  .LeaS1fFr::after {
    content: '';
    display: block;
    height: 0.75rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .LeaS1fFr {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
            justify-content: center;
    padding: 0.5rem 1rem;
  }
  .LeaS1fFr::after {
    display: none;
  }
}
.J2HP87iK {
  --server-keyboard-offset: 0px;
  position: relative;
  width: 100%;
  max-width: 25.875rem;
  box-sizing: border-box;
  padding: 2.5875rem 2.3rem 2.3rem;
  background: #fffdf4;
  border-radius: 2.3rem;
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);
  -webkit-animation: LTjc1z3e 0.3s ease;
          animation: LTjc1z3e 0.3s ease;
  -webkit-transform: translate3d(0, calc(0px - var(--server-keyboard-offset)), 0);
          transform: translate3d(0, calc(0px - var(--server-keyboard-offset)), 0);
  -webkit-transition: -webkit-transform 0.18s ease;
  transition: -webkit-transform 0.18s ease;
  transition: transform 0.18s ease;
  transition: transform 0.18s ease, -webkit-transform 0.18s ease;
  overflow: visible;
  max-height: none;
}
@media (max-width: 767px) {
  .J2HP87iK {
    max-width: 90%;
    padding: 2.3rem 1.725rem 2.0125rem;
    border-radius: 2.0125rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .J2HP87iK {
    max-height: calc(var(--app-viewport-height, 100dvh) - 1.5rem);
    margin-left: auto;
    margin-right: auto;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .J2HP87iK {
    width: min(25.875rem, 82vw);
    max-width: min(25.875rem, 82vw);
    max-height: none;
    padding: 2.3rem 1.725rem 2.0125rem;
    border-radius: 2.0125rem;
    margin: auto;
  }
}
@-webkit-keyframes LTjc1z3e {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes LTjc1z3e {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.OvPYSVbM {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  top: -0.8625rem;
  right: -1.4375rem;
  width: 4.025rem;
  height: 4.025rem;
  padding: 0;
  border: none;
  background: transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  z-index: 2;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
.OvPYSVbM:hover {
  -webkit-transform: scale(1.05);
          transform: scale(1.05);
}
.OvPYSVbM:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .OvPYSVbM {
    top: -0.71875rem;
    right: -1.00625rem;
    width: 3.45rem;
    height: 3.45rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .OvPYSVbM {
    top: -0.71875rem;
    right: -1.00625rem;
    width: 3.45rem;
    height: 3.45rem;
  }
}
.wB18_7y7 {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: contain;
     object-fit: contain;
}
.HvSwzAXT {
  margin: 0 0 2.3rem;
  font-size: 1.725rem;
  font-weight: bold;
  color: #5e5447;
  text-align: center;
  line-height: 1.3;
}
@media (max-width: 767px) {
  .HvSwzAXT {
    font-size: 1.4375rem;
    margin-bottom: 1.725rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .HvSwzAXT {
    margin-bottom: 0.5rem;
    font-size: 1.125rem;
    line-height: 1.2;
  }
}
.fZaUwFkV {
  margin-bottom: 1.15rem;
  position: relative;
  z-index: 1;
}
.fZaUwFkV:has(.PkBvn5OD) {
  z-index: 20;
}
.fZaUwFkV:last-of-type {
  margin-bottom: 1.725rem;
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .fZaUwFkV {
    margin-bottom: 0.5rem;
  }
  .fZaUwFkV:last-of-type {
    margin-bottom: 0.5rem;
  }
}
.npbYB_aD {
  position: relative;
  border: 3px solid #fbd9b9;
  border-radius: 1.725rem;
  background: #fff1db;
  overflow: hidden;
  -webkit-transition: box-shadow 0.32s cubic-bezier(0.33, 1, 0.68, 1), border-radius 0.32s cubic-bezier(0.33, 1, 0.68, 1), border-color 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: box-shadow 0.32s cubic-bezier(0.33, 1, 0.68, 1), border-radius 0.32s cubic-bezier(0.33, 1, 0.68, 1), border-color 0.32s cubic-bezier(0.33, 1, 0.68, 1);
}
.npbYB_aD.PkBvn5OD {
  overflow: visible;
  border-radius: 1.725rem 1.725rem 0 0;
  border-bottom-color: transparent;
  box-shadow: 0 0.125rem 0.375rem rgba(94, 84, 71, 0.06);
}
.npbYB_aD.PkBvn5OD .IrhIZmS7 {
  grid-template-rows: 1fr;
  pointer-events: auto;
}
.npbYB_aD.PkBvn5OD .uKhqf4zw {
  border-color: #fbd9b9;
  border-width: 3px;
  border-top-color: #e8dcc8;
  box-shadow: 0 0.375rem 0.75rem rgba(94, 84, 71, 0.12);
}
.npbYB_aD.PkBvn5OD .uKhqf4zw::before {
  opacity: 1;
}
.npbYB_aD.JEybOeGd {
  opacity: 0.72;
  cursor: not-allowed;
}
._969EMhxi {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  min-width: 0;
  border: none;
  border-radius: inherit;
  background: transparent;
  z-index: 1;
  min-height: 3.45rem;
}
@media (max-width: 767px) {
  ._969EMhxi {
    min-height: 3.1625rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  ._969EMhxi {
    min-height: 2.5rem;
  }
}
.wPGGxgm5 {
  min-height: auto;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
          align-items: stretch;
}
.bKdnsQEy {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  min-width: 0;
  width: 100%;
  padding: 1.00625rem 0.575rem 1.00625rem 1.4375rem;
  border: none;
  outline: none;
  font-size: 1.15rem;
  font-weight: bold;
  color: #5e5447;
  background: transparent;
  line-height: 1.4;
}
.bKdnsQEy::-webkit-input-placeholder {
  color: #5e5447;
  font-weight: bold;
  opacity: 0.88;
}
.bKdnsQEy::-moz-placeholder {
  color: #5e5447;
  font-weight: bold;
  opacity: 0.88;
}
.bKdnsQEy::placeholder {
  color: #5e5447;
  font-weight: bold;
  opacity: 0.88;
}
@media (max-width: 767px) {
  .bKdnsQEy {
    padding: 0.8625rem 0.43125rem 0.8625rem 1.00625rem;
    font-size: 1.00625rem;
  }
  .bKdnsQEy::-webkit-input-placeholder {
    font-size: 0.75rem;
    line-height: 1.2;
  }
  .bKdnsQEy::-moz-placeholder {
    font-size: 0.75rem;
    line-height: 1.2;
  }
  .bKdnsQEy::placeholder {
    font-size: 0.75rem;
    line-height: 1.2;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .bKdnsQEy {
    padding: 0.5rem 0.375rem 0.5rem 0.875rem;
    font-size: 0.875rem;
  }
}
.fRY7LXYD {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  min-width: 0;
  padding: 1.00625rem 0.575rem 1.00625rem 1.4375rem;
  font-size: 1.15rem;
  font-weight: bold;
  color: #5e5447;
  line-height: 1.25;
  opacity: 0.88;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: normal;
  pointer-events: none;
}
@media (max-width: 767px) {
  .fRY7LXYD {
    padding: 0.8625rem 0.43125rem 0.8625rem 1.00625rem;
    font-size: 0.75rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .fRY7LXYD {
    padding: 0.5rem 0.375rem 0.5rem 0.875rem;
    font-size: 0.875rem;
  }
}
.wPGGxgm5 .bKdnsQEy {
  position: absolute;
  inset: 0;
  z-index: 1;
  padding: 0;
  opacity: 0;
}
.Ymu4vWVF {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  padding: 1.00625rem 0.575rem 1.00625rem 1.4375rem;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  outline: none;
  min-height: 3.45rem;
}
.Ymu4vWVF.Ze5UZdoN {
  cursor: not-allowed;
}
@media (max-width: 767px) {
  .Ymu4vWVF {
    padding: 0.8625rem 0.43125rem 0.8625rem 1.00625rem;
    min-height: 3.1625rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .Ymu4vWVF {
    min-height: 2.5rem;
    padding: 0.5rem 0.375rem 0.5rem 0.875rem;
  }
}
.nj9mfuGx {
  font-size: 1.15rem;
  font-weight: bold;
  color: #5e5447;
  width: 100%;
}
@media (max-width: 767px) {
  .nj9mfuGx {
    font-size: 1.00625rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .nj9mfuGx {
    font-size: 0.875rem;
  }
}
.zwv60tv4 {
  font-size: 1.15rem;
  font-weight: bold;
  color: #c9a574;
}
@media (max-width: 767px) {
  .zwv60tv4 {
    font-size: 0.75rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .zwv60tv4 {
    font-size: 0.875rem;
  }
}
.TqWA51oL {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: relative;
  z-index: 2;
  padding: 1.00625rem 1.29375rem 1.00625rem 0.575rem;
  background: transparent;
  border: none;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .TqWA51oL {
    padding: 0.8625rem 0.8625rem 0.8625rem 0.43125rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .TqWA51oL {
    padding: 0.5rem 0.875rem 0.5rem 0.375rem;
  }
}
.VgvIGa05 {
  width: 1.15rem;
  height: 1.15rem;
  -webkit-transition: -webkit-transform 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: -webkit-transform 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: transform 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: transform 0.32s cubic-bezier(0.33, 1, 0.68, 1), -webkit-transform 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  display: inline-block;
}
.V34fDr4G {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}
.IrhIZmS7 {
  position: absolute;
  top: 100%;
  left: -3px;
  right: -3px;
  z-index: 2;
  display: grid;
  grid-template-rows: 0fr;
  margin-top: -3px;
  -webkit-transition: grid-template-rows 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: grid-template-rows 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  pointer-events: none;
}
.uKhqf4zw {
  min-height: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: #fff1db;
  border: 3px solid transparent;
  border-radius: 0 0 1.725rem 1.725rem;
  -webkit-transition: border-color 0.32s cubic-bezier(0.33, 1, 0.68, 1), box-shadow 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: border-color 0.32s cubic-bezier(0.33, 1, 0.68, 1), box-shadow 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  border-top: none;
}
.uKhqf4zw::before {
  content: '';
  display: block;
  width: 90%;
  height: 2px;
  background: #fbd9b9;
  opacity: 0;
  margin: 0 auto;
}
.uKhqf4zw.a1vBnoQS {
  max-height: 8.97rem;
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .uKhqf4zw.a1vBnoQS {
    max-height: 8rem;
  }
}
.uKhqf4zw.zaoWmaQV {
  overflow-y: auto;
}
@media (hover: none) and (pointer: coarse) and (orientation: portrait) {
  .uKhqf4zw.a1vBnoQS {
    max-height: 8.97rem;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: portrait) {
  .ifgvu7Gp .a1vBnoQS {
    max-height: 8.97rem;
  }
}
.PkycylE_ {
  padding: 0.71875rem 0;
  cursor: pointer;
  font-size: 1.15rem;
  font-weight: bold;
  color: #5e5447;
  text-align: center;
  -webkit-transition: background-color 0.2s ease, color 0.2s ease;
  transition: background-color 0.2s ease, color 0.2s ease;
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.PkycylE_:hover {
  color: #ff8100;
}
.PkycylE_.IaZIvCvG {
  color: #ff8100;
  background: #fff1db;
}
@media (max-width: 767px) {
  .PkycylE_ {
    padding: 0.646875rem 1.15rem;
    padding-left: 0.3rem;
    font-size: 1.00625rem;
    color: #5e5447;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .PkycylE_ {
    padding: 0.4375rem 0.875rem;
    padding-left: 0.3rem;
    font-size: 0.875rem;
  }
}
.OvuUhSxr {
  padding: 1.00625rem 1.4375rem;
  font-size: 1.00625rem;
  font-weight: bold;
  color: #c9a574;
  text-align: center;
}
@media (max-width: 767px) {
  .OvuUhSxr {
    padding: 0.8625rem 1.15rem;
    font-size: 0.8625rem;
  }
}
.Ipquc5gU {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  width: 100%;
  padding: 1.078125rem 1.725rem;
  background: #ff8100;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-size: 1.29375rem;
  font-weight: bold;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease, -webkit-transform 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
}
.Ipquc5gU:hover {
  background: #e67400;
}
.Ipquc5gU:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .Ipquc5gU {
    font-size: 1.15rem;
    padding: 1.00625rem 1.15rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .Ipquc5gU {
    min-height: 2.25rem;
    padding: 0.5rem 1rem;
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServerSelectModal/ServerSelectModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAsBA;EACE,eAAA;EACA,QAAA;EACA,aAAA;ECoCA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDpCA,kBAAA;EC8FA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,iCAAA;EACA,mBAAA;ADhHF;ACkHE;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,+BAAA;EACA,0BAAA;EACA,kCAAA;EACA,WAAA;EACA,oBAAA;ADhHJ;ACsHE;EAAA;IACE,cAAA;IACA,0BAAA;IAAA,4BAAA;YAAA,oBAAA;IACA,yBAAA;IAAA,gCAAA;YAAA,wBAAA;IACA,qBAAA;IACA,kBAAA;IACA,gBAAA;IACA,4BAAA;IACA,iCAAA;IACA,mBAAA;EDnHF;ECqHE;IACE,WAAA;IACA,cAAA;IACA,eAAA;EDnHJ;AACF;AAVE;EAAA;IACE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,wBAAA;IAAA,+BAAA;YAAA,uBAAA;IACA,oBAAA;EAaF;EAXE;IACE,aAAA;EAaJ;AACF;AATA;EACE,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;EACA,+CAAA;EACA,qCAAA;UAAA,6BAAA;EACA,+EAAA;UAAA,uEAAA;EACA,gDAAA;EAAA,wCAAA;EAAA,gCAAA;EAAA,8DAAA;EACA,iBAAA;EAEA,gBAAA;AAUF;ACjEE;EAAA;ID0DE,cAAA;IACA,kCAAA;IACA,wBAAA;EAWF;AACF;ACsFE;EAAA;IACE,6DAAA;IACA,iBAAA;IACA,kBAAA;EDnFF;AACF;AAdE;EAAA;IACE,2BAAA;IACA,+BAAA;IACA,gBAAA;IACA,kCAAA;IACA,wBAAA;IACA,YAAA;EAiBF;AACF;AAdA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAgBF;EAdA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAgBF;AACF;AAxBA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAgBF;EAdA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAgBF;AACF;AAbA;ECeE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;EDlBA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AAkBF;AAhBE;EACE,8BAAA;UAAA,sBAAA;AAkBJ;AAfE;EACE,8BAAA;UAAA,sBAAA;AAiBJ;AC7HE;EAAA;IDgHE,gBAAA;IACA,kBAAA;IACA,cAAA;IACA,eAAA;EAiBF;AACF;AAfE;EAAA;IACE,gBAAA;IACA,kBAAA;IACA,cAAA;IACA,eAAA;EAkBF;AACF;AAfA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;AAiBF;AAdA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAgBF;AC3JE;EAAA;ID8IE,oBAAA;IACA,uBAAA;EAiBF;AACF;AAfE;EAAA;IACE,qBAAA;IACA,mBAAA;IACA,gBAAA;EAkBF;AACF;AAfA;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;AAiBF;AAfE;EACE,WAAA;AAiBJ;AAdE;EACE,uBAAA;AAgBJ;AAbE;EAAA;IACE,qBAAA;EAgBF;EAdE;IACE,qBAAA;EAgBJ;AACF;AAZA;EACE,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0KAAA;EAAA,kKAAA;AAcF;AATE;EACE,iBAAA;EACA,oCAAA;EACA,gCAAA;EACA,sDAAA;AAWJ;AAfE;EAOI,uBAAA;EACA,oBAAA;AAWN;AAnBE;EAYI,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qDAAA;AAUN;AARM;EACE,UAAA;AAUR;AALE;EACE,aAAA;EACA,mBAAA;AAOJ;AAHA;EACE,kBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AAKF;ACrOE;EAAA;IDmOE,qBAAA;EAMF;AACF;AAJE;EAAA;IACE,kBAAA;EAOF;AACF;AAJA;EACE,gBAAA;EACA,0BAAA;EAAA,4BAAA;UAAA,oBAAA;AAMF;AAHA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,YAAA;EACA,WAAA;EACA,iDAAA;EAEA,YAAA;EACA,aAAA;EAEA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;AAGF;AADE;EACE,cAAA;EACA,iBAAA;EACA,aAAA;AAGJ;AANE;EACE,cAAA;EACA,iBAAA;EACA,aAAA;AAGJ;AANE;EACE,cAAA;EACA,iBAAA;EACA,aAAA;AAGJ;ACrQE;EAAA;IDsQE,kDAAA;IAEA,qBAAA;EAEF;EAAE;IACE,kBAAA;IACA,gBAAA;EAEJ;EAJE;IACE,kBAAA;IACA,gBAAA;EAEJ;EAJE;IACE,kBAAA;IACA,gBAAA;EAEJ;AACF;AACE;EAAA;IACE,wCAAA;IACA,mBAAA;EAEF;AACF;AACA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,YAAA;EACA,iDAAA;EAGA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AADF;ACnSE;EAAA;IDuSE,kDAAA;IAEA,kBAAA;EADF;AACF;AAGE;EAAA;IACE,wCAAA;IACA,mBAAA;EAAF;AACF;AAGA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;AADF;AAIA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,iDAAA;EAEA,eAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,aAAA;EACA,mBAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;AClUE;EAAA;IDyUE,kDAAA;IAEA,qBAAA;EAJF;AACF;AAME;EAAA;IACE,kBAAA;IACA,wCAAA;EAHF;AACF;AAMA;EAEE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AALF;ACpVE;EAAA;ID4VE,qBAAA;EAJF;AACF;AAME;EAAA;IACE,mBAAA;EAHF;AACF;AAMA;EAEE,kBAAA;EACA,iBAAA;EACA,cAAA;AALF;ACnWE;EAAA;ID2WE,kBAAA;EAJF;AACF;AAME;EAAA;IACE,mBAAA;EAHF;AACF;AAMA;EC9QE,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;ED2QA,kBAAA;EACA,UAAA;EACA,kDAAA;EAEA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,sBAAA;UAAA,cAAA;AADF;AC9XE;EAAA;IDkYE,iDAAA;EAAF;AACF;AAGE;EAAA;IACE,wCAAA;EAAF;AACF;AAGA;EACE,cAAA;EACA,eAAA;EACA,0EAAA;EAAA,kEAAA;EAAA,0DAAA;EAAA,kHAAA;EACA,qBAAA;AADF;AAIA;EACE,iCAAA;UAAA,yBAAA;AAFF;AAKA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,2EAAA;EAAA,mEAAA;EACA,oBAAA;AAHF;AAMA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,sHAAA;EAAA,8GAAA;EAGA,gBAAA;AANF;AAQE;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;AANJ;AASE;EACE,mBAAA;AAPJ;AAUE;EACE;IACE,gBAAA;EARJ;AACF;AAWE;EACE,gBAAA;AATJ;AAYE;EACE;IACE,mBAAA;IACA,gBAAA;IACA,4BAAA;IACA,iCAAA;EAVJ;AACF;AAeE;EAAA;IAEI,mBAAA;EAbJ;AACF;AAiBA;EACE,qBAAA;EACA,eAAA;EAEA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,+DAAA;EAAA,uDAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AAhBF;AAkBE;EACE,cAAA;AAhBJ;AAmBE;EACE,cAAA;EACA,mBAAA;AAjBJ;AC3dE;EAAA;IDgfE,4BAAA;IACA,oBAAA;IACA,qBAAA;IACA,cAAA;EAjBF;AACF;AAmBE;EAAA;IACE,2BAAA;IACA,oBAAA;IACA,mBAAA;EAhBF;AACF;AAmBA;EACE,6BAAA;EAEA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAlBF;ACjfE;EAAA;IDsgBE,0BAAA;IACA,oBAAA;EAjBF;AACF;AAoBA;ECtaE,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDmaA,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EAEA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,2EAAA;EAAA,mEAAA;EAAA,2DAAA;EAAA,wFAAA;ECxaA,mBAAA;EACA,kBAAA;AD0ZF;AAgBE;EACE,mBAAA;AAdJ;AAiBE;EACE,8BAAA;UAAA,sBAAA;AAfJ;AChhBE;EAAA;IDmiBE,kBAAA;IACA,2BAAA;EAfF;AACF;AAiBE;EAAA;IACE,mBAAA;IACA,oBAAA;IACA,eAAA;EAdF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n@server-modal-bg: #fffdf4;\n@server-modal-text: #5e5447;\n@server-modal-orange: #ff8100;\n@server-modal-orange-dark: #e67400;\n@server-modal-input-bg: #fff1db;\n@server-modal-input-border: #fbd9b9;\n@server-modal-placeholder: #c9a574;\n@server-modal-chevron: #ff9a3d;\n@server-modal-scale: 1.15;\n@server-modal-base-width: 22.5rem;\n@server-select-radius: (1.5rem * @server-modal-scale);\n@server-select-pill-radius: ((3rem * @server-modal-scale) / 2);\n@server-select-transition: 0.32s cubic-bezier(0.33, 1, 0.68, 1);\n@server-dropdown-visible-count: 3;\n@server-dropdown-item-block-size: (\n  (0.625rem * 2 * @server-modal-scale) + (@font-size-md * @server-modal-scale * 1.35)\n);\n@server-dropdown-scroll-max-height: (@server-dropdown-item-block-size * @server-dropdown-visible-count);\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  z-index: @z-index-modal;\n  .flex-center();\n  padding: @spacing-xl @spacing-md;\n  .modalOverlayBackdrop();\n\n  .touchLandscapeModalOverlay(0.75rem, 1rem);\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: @spacing-sm @spacing-md;\n\n    &::after {\n      display: none;\n    }\n  }\n}\n\n.modal {\n  --server-keyboard-offset: 0px;\n  position: relative;\n  width: 100%;\n  max-width: (@server-modal-base-width * @server-modal-scale);\n  box-sizing: border-box;\n  padding: (2.25rem * @server-modal-scale) (2rem * @server-modal-scale) (2rem * @server-modal-scale);\n  background: @server-modal-bg;\n  border-radius: (2rem * @server-modal-scale);\n  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);\n  animation: slideUp 0.3s ease;\n  transform: translate3d(0, calc(0px - var(--server-keyboard-offset)), 0);\n  transition: transform 0.18s ease;\n  overflow: visible;\n  \n  max-height: none;\n\n  .mobile({\n    max-width: 90%;\n    padding: (2rem * @server-modal-scale) (1.5rem * @server-modal-scale) (1.75rem * @server-modal-scale);\n    border-radius: (1.75rem * @server-modal-scale);\n  });\n\n  .touchLandscapeModalBox(1.5rem);\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    width: min((@server-modal-base-width * @server-modal-scale), 82vw);\n    max-width: min((@server-modal-base-width * @server-modal-scale), 82vw);\n    max-height: none;\n    padding: (2rem * @server-modal-scale) (1.5rem * @server-modal-scale) (1.75rem * @server-modal-scale);\n    border-radius: (1.75rem * @server-modal-scale);\n    margin: auto;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.closeButton {\n  .button-reset();\n  position: absolute;\n  top: (-0.75rem * @server-modal-scale);\n  right: (-1.25rem * @server-modal-scale);\n  width: (3.5rem * @server-modal-scale);\n  height: (3.5rem * @server-modal-scale);\n  padding: 0;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    top: (-0.625rem * @server-modal-scale);\n    right: (-0.875rem * @server-modal-scale);\n    width: (3rem * @server-modal-scale);\n    height: (3rem * @server-modal-scale);\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    top: (-0.625rem * @server-modal-scale);\n    right: (-0.875rem * @server-modal-scale);\n    width: (3rem * @server-modal-scale);\n    height: (3rem * @server-modal-scale);\n  }\n}\n\n.closeButtonImg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n\n.title {\n  margin: 0 0 (@spacing-xl * @server-modal-scale);\n  font-size: (@font-size-xxl * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-text;\n  text-align: center;\n  line-height: 1.3;\n\n  .mobile({\n    font-size: (@font-size-xl * @server-modal-scale);\n    margin-bottom: (@spacing-lg * @server-modal-scale);\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    margin-bottom: @spacing-sm;\n    font-size: @font-size-lg;\n    line-height: 1.2;\n  }\n}\n\n.inputGroup {\n  margin-bottom: (@spacing-md * @server-modal-scale);\n  position: relative;\n  z-index: 1;\n\n  &:has(.selectControlOpen) {\n    z-index: 20;\n  }\n\n  &:last-of-type {\n    margin-bottom: (@spacing-lg * @server-modal-scale);\n  }\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    margin-bottom: @spacing-sm;\n\n    &:last-of-type {\n      margin-bottom: @spacing-sm;\n    }\n  }\n}\n\n.selectControl {\n  position: relative;\n  border: 3px solid @server-modal-input-border;\n  border-radius: @server-select-pill-radius;\n  background: @server-modal-input-bg;\n  overflow: hidden;\n  transition:\n    box-shadow @server-select-transition,\n    border-radius @server-select-transition,\n    border-color @server-select-transition;\n\n  &.selectControlOpen {\n    overflow: visible;\n    border-radius: @server-select-pill-radius @server-select-pill-radius 0 0;\n    border-bottom-color: transparent;\n    box-shadow: 0 0.125rem 0.375rem rgba(94, 84, 71, 0.06);\n\n    .dropdownCollapse {\n      grid-template-rows: 1fr;\n      pointer-events: auto;\n    }\n\n    .dropdownList {\n      border-color: @server-modal-input-border;\n      border-width: 3px;\n      border-top-color: #e8dcc8;\n      box-shadow: 0 0.375rem 0.75rem rgba(94, 84, 71, 0.12);\n\n      &::before {\n        opacity: 1;\n      }\n    }\n  }\n\n  &.selectControlDisabled {\n    opacity: 0.72;\n    cursor: not-allowed;\n  }\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  border: none;\n  border-radius: inherit;\n  background: transparent;\n  z-index: 1;\n  min-height: (3rem * @server-modal-scale);\n\n  .mobile({\n    min-height: (2.75rem * @server-modal-scale);\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    min-height: 2.5rem;\n  }\n}\n\n.inputWrapperWithServerPlaceholder {\n  min-height: auto;\n  align-items: stretch;\n}\n\n.input {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  padding: (0.875rem * @server-modal-scale) (0.5rem * @server-modal-scale) (0.875rem * @server-modal-scale)\n    (1.25rem * @server-modal-scale);\n  border: none;\n  outline: none;\n  \n  font-size: (@font-size-md * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-text;\n  background: transparent;\n  line-height: 1.4;\n\n  &::placeholder {\n    color: @server-modal-text;\n    font-weight: bold;\n    opacity: 0.88;\n  }\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (0.375rem * @server-modal-scale) (0.75rem * @server-modal-scale)\n      (0.875rem * @server-modal-scale);\n    font-size: (@font-size-sm * @server-modal-scale);\n\n    &::placeholder {\n      font-size: @font-size-xs;\n      line-height: 1.2;\n    }\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    padding: 0.5rem 0.375rem 0.5rem 0.875rem;\n    font-size: @font-size-sm;\n  }\n}\n\n.serverPlaceholder {\n  flex: 1;\n  min-width: 0;\n  padding: (0.875rem * @server-modal-scale) (0.5rem * @server-modal-scale) (0.875rem * @server-modal-scale)\n    (1.25rem * @server-modal-scale);\n  \n  font-size: (@font-size-md * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-text;\n  line-height: 1.25;\n  opacity: 0.88;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: normal;\n  pointer-events: none;\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (0.375rem * @server-modal-scale) (0.75rem * @server-modal-scale)\n      (0.875rem * @server-modal-scale);\n    font-size: @font-size-xs;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    padding: 0.5rem 0.375rem 0.5rem 0.875rem;\n    font-size: @font-size-sm;\n  }\n}\n\n.inputWrapperWithServerPlaceholder .input {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  padding: 0;\n  opacity: 0;\n}\n\n.characterInput {\n  flex: 1;\n  padding: (0.875rem * @server-modal-scale) (0.5rem * @server-modal-scale) (0.875rem * @server-modal-scale)\n    (1.25rem * @server-modal-scale);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  outline: none;\n  min-height: (3rem * @server-modal-scale);\n\n  &.characterInputDisabled {\n    cursor: not-allowed;\n  }\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (0.375rem * @server-modal-scale) (0.75rem * @server-modal-scale)\n      (0.875rem * @server-modal-scale);\n    min-height: (2.75rem * @server-modal-scale);\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    min-height: 2.5rem;\n    padding: 0.5rem 0.375rem 0.5rem 0.875rem;\n  }\n}\n\n.characterName {\n  \n  font-size: (@font-size-md * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-text;\n  width: 100%;\n\n  .mobile({\n    font-size: (@font-size-sm * @server-modal-scale);\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    font-size: @font-size-sm;\n  }\n}\n\n.characterPlaceholder {\n  \n  font-size: (@font-size-md * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-placeholder;\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    font-size: @font-size-sm;\n  }\n}\n\n.dropdownButton {\n  .button-reset();\n  position: relative;\n  z-index: 2;\n  padding: (0.875rem * @server-modal-scale) (1.125rem * @server-modal-scale) (0.875rem * @server-modal-scale)\n    (0.5rem * @server-modal-scale);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (0.75rem * @server-modal-scale) (0.75rem * @server-modal-scale)\n      (0.375rem * @server-modal-scale);\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    padding: 0.5rem 0.875rem 0.5rem 0.375rem;\n  }\n}\n\n.chevron {\n  width: (1rem * @server-modal-scale);\n  height: (1rem * @server-modal-scale);\n  transition: transform @server-select-transition;\n  display: inline-block;\n}\n\n.chevronOpen {\n  transform: rotate(180deg);\n}\n\n.dropdownCollapse {\n  position: absolute;\n  top: 100%;\n  left: -3px;\n  right: -3px;\n  z-index: 2;\n  display: grid;\n  grid-template-rows: 0fr;\n  margin-top: -3px;\n  transition: grid-template-rows @server-select-transition;\n  pointer-events: none;\n}\n\n.dropdownList {\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  background-color: @server-modal-input-bg;\n  border: 3px solid transparent;\n  border-radius: 0 0 @server-select-pill-radius @server-select-pill-radius;\n  transition:\n    border-color @server-select-transition,\n    box-shadow @server-select-transition;\n  border-top: none;\n\n  &::before {\n    content: '';\n    display: block;\n    width: 90%;\n    height: 2px;\n    background: @server-modal-input-border;\n    opacity: 0;\n    margin: 0 auto;\n  }\n\n  &.dropdownListCapped {\n    max-height: @server-dropdown-scroll-max-height;\n  }\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    &.dropdownListCapped {\n      max-height: min(@server-dropdown-scroll-max-height, 8rem);\n    }\n  }\n\n  &.dropdownListScrollable {\n    overflow-y: auto;\n  }\n\n  @media (hover: none) and (pointer: coarse) and (orientation: portrait) {\n    &.dropdownListCapped {\n      max-height: @server-dropdown-scroll-max-height;\n      overflow-y: auto;\n      overscroll-behavior: contain;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n\n.selectControlKeyboardActive {\n  @media (hover: none) and (pointer: coarse) and (orientation: portrait) {\n    .dropdownListCapped {\n      max-height: @server-dropdown-scroll-max-height;\n    }\n  }\n}\n\n.dropdownItem {\n  padding: (0.625rem * @server-modal-scale) 0;\n  cursor: pointer;\n  \n  font-size: (@font-size-md * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-text;\n  text-align: center;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  width: 90%;\n  margin: 0 auto;\n  text-align: left;\n\n  &:hover {\n    color: @server-modal-orange;\n  }\n\n  &.dropdownItemSelected {\n    color: @server-modal-orange;\n    background: #fff1db;\n  }\n\n  .mobile({\n    padding: (0.5625rem * @server-modal-scale) (1rem * @server-modal-scale);\n    padding-left: 0.3rem;\n    font-size: (@font-size-sm * @server-modal-scale);\n    color: @server-modal-text;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    padding: 0.4375rem 0.875rem;\n    padding-left: 0.3rem;\n    font-size: @font-size-sm;\n  }\n}\n\n.dropdownItemEmpty {\n  padding: (0.875rem * @server-modal-scale) (1.25rem * @server-modal-scale);\n  \n  font-size: (@font-size-sm * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-placeholder;\n  text-align: center;\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (1rem * @server-modal-scale);\n    font-size: (@font-size-xs * @server-modal-scale);\n  });\n}\n\n.confirmButton {\n  .button-reset();\n  width: 100%;\n  padding: (0.9375rem * @server-modal-scale) (@spacing-lg * @server-modal-scale);\n  background: @server-modal-orange;\n  border: none;\n  border-radius: 999px;\n  color: @white;\n  \n  font-size: (@font-size-lg * @server-modal-scale);\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n  .touch-friendly();\n\n  &:hover {\n    background: @server-modal-orange-dark;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: (@font-size-md * @server-modal-scale);\n    padding: (0.875rem * @server-modal-scale) (@spacing-md * @server-modal-scale);\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    min-height: 2.25rem;\n    padding: 0.5rem @spacing-md;\n    font-size: @font-size-md;\n  }\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  touch-action: pan-y;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n\n// 触屏设备横屏时高度很矮，弹窗蒙版必须允许自身滚动，并从顶部开始排布。\n.touchLandscapeModalOverlay(@padding-y: @spacing-sm, @padding-x: @spacing-md) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    display: block;\n    align-items: initial;\n    justify-content: initial;\n    padding: @padding-y @padding-x;\n    overflow-x: hidden;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    touch-action: pan-y;\n\n    &::after {\n      content: '';\n      display: block;\n      height: @padding-y;\n    }\n  }\n}\n\n.touchLandscapeModalBox(@max-height-gap: (@spacing-sm * 2)) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    max-height: calc(var(--app-viewport-height, 100dvh) - @max-height-gap);\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `LeaS1fFr`,
	"modal": `J2HP87iK`,
	"slideUp": `LTjc1z3e`,
	"closeButton": `OvPYSVbM`,
	"closeButtonImg": `wB18_7y7`,
	"title": `HvSwzAXT`,
	"inputGroup": `fZaUwFkV`,
	"selectControlOpen": `PkBvn5OD`,
	"selectControl": `npbYB_aD`,
	"dropdownCollapse": `IrhIZmS7`,
	"dropdownList": `uKhqf4zw`,
	"selectControlDisabled": `JEybOeGd`,
	"inputWrapper": `_969EMhxi`,
	"inputWrapperWithServerPlaceholder": `wPGGxgm5`,
	"input": `bKdnsQEy`,
	"serverPlaceholder": `fRY7LXYD`,
	"characterInput": `Ymu4vWVF`,
	"characterInputDisabled": `Ze5UZdoN`,
	"characterName": `nj9mfuGx`,
	"characterPlaceholder": `zwv60tv4`,
	"dropdownButton": `TqWA51oL`,
	"chevron": `VgvIGa05`,
	"chevronOpen": `V34fDr4G`,
	"dropdownListCapped": `a1vBnoQS`,
	"dropdownListScrollable": `zaoWmaQV`,
	"selectControlKeyboardActive": `ifgvu7Gp`,
	"dropdownItem": `PkycylE_`,
	"dropdownItemSelected": `IaZIvCvG`,
	"dropdownItemEmpty": `OvuUhSxr`,
	"confirmButton": `Ipquc5gU`
};
export default ___CSS_LOADER_EXPORT___;
